var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ColumnEditModal",
    _vm._b(
      {
        attrs: {
          value: _vm.value,
          configName: _vm.configName,
          columnId: _vm.columnId,
          editMode: _vm.editMode,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "edit-modal-additions",
            fn: function (props) {
              return [
                _c(
                  "v-layout",
                  { attrs: { "pa-4": "", wrap: "" } },
                  [
                    _c("h3", [
                      _vm._v(
                        ' If the cell contains a value, the cell in the "VMV Code" column must be an integer. '
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: {
                          column: "",
                          value: _vm.getShouldValidateDataTypeValue(
                            props.columnConfiguration
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.callSetColumnMetadata(
                              _vm.shouldValidateDataTypeKey,
                              !_vm.getShouldValidateDataTypeValue(
                                props.columnConfiguration
                              )
                            )
                          },
                        },
                      },
                      [
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "The import will fail if a non-integer is detected.",
                            value: true,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "The import will continue if a non-integer is detected, but the VMV Code will not be stored.",
                            value: false,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      },
      "ColumnEditModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }